export default (state, accessToken) => {
  localStorage.setItem('token', accessToken);
  state.token = accessToken;
}
